export default "__VITE_ASSET__BxjmU$2c__"